export enum IconsSocial {
    'apple-store' = 'apple-store',
    facebook = 'facebook',
    'google-play' = 'google-play',
    google = 'google',
    instagram = 'instagram',
    spotify = 'spotify',
    tiktok = 'tiktok',
}

export enum Icons {
    'pw-hide' = 'pw-hide-outline',
    'pw-show' = 'pw-show-outline',
    'alert-check-filled' = 'alert-check-filled',
    calendar = 'calendar-outline',
    card = 'card-outline',
    close = 'close-outline',
    copy = 'copy-outline',
    delete = 'delete-outline',
    'delete-timer' = 'delete-timer',
    email = 'email-outline',
    events = 'events-outline',
    heart = 'heart-outline',
    filter = 'filter-outline',
    info = 'info-outline',
    map = 'map-outline',
    notification = 'notification-outline',
    phone = 'phone-outline',
    search = 'search-outline',
    settings = 'settings-outline',
    'alert-warning-filled' = 'alert-warning-filled',
    'open-in-new' = 'open-in-new-outline',
    'sidebar-collapsed' = 'sidebar-collapsed-outline',
    'sidebar-expanded' = 'sidebar-expanded-outline',
    add = 'add-outline',
    edit = 'edit-outline',
    'edit-filled' = 'edit-filled',
    download = 'download-outline',
    expand = 'expand-outline',
    collapse = 'collapse-outline',
    restore = 'restore-outline',
    check = 'check-outline',
    minus = 'minus-outline',
    repeat = 'repeat-outline',
    drag = 'drag-outline',
    logout = 'logout-outline',
    upload = 'upload-outline',
    lock = 'lock-outline',
    image = 'image-outline',
    'zoom-in' = 'zoom-in-outline',
    'zoom-out' = 'zoom-out-outline',
    'back-to-top' = 'back-to-top-outline',
    id = 'id-outline',
    'alert-error-filled' = 'alert-error-filled',
    'caution-filled' = 'caution-filled',
    'notification-active' = 'notification-active-outline',
    users = 'users-outline',
    file = 'file-outline',
    gift = 'gift-outline',
    home = 'home-outline',
    money = 'money-outline',
    ticket = 'ticket-outline',
    lifestyle = 'lifestyle-outline',
    down = 'down-outline',
    overflow = 'overflow-outline',
    hourglass = 'hourglass-outline',
    burger = 'burger-outline',
    user = 'user-outline',
    help = 'help-outline',
    back = 'back-outline',
    forward = 'forward-outline',
    up = 'up-outline',
    location = 'location-outline',
    'location-filled' = 'location-filled',
    duration = 'duration-outline',
    language = 'language-outline',
    category = 'category-outline',
    receipts = 'receipts-outline',
    'lightning-bolt' = 'lightning-bolt-outline',
    'info-filled' = 'info-filled',
    'reset-password' = 'reset-password-outline',
    insurance = 'insurance-outline',
}

export const IconNames = Object.keys(Icons).reduce(
    (acc, key) => {
        acc[key] = key;
        return acc;
    },
    {} as Record<keyof typeof Icons, keyof typeof Icons>,
);

export type IconNamesType = keyof typeof Icons;

export enum IconsColored {
    'heart-filled' = 'heart-filled',
    'heart-outline' = 'heart-outline',
    person = 'person',
    'shopping-cart' = 'shopping-cart',
    verified = 'verified',
    visa = 'visa',
    mastercard = 'mastercard',
    'filled-star' = 'filled-star',
    'empty-star' = 'empty-star',
    diamond = 'diamond',
    discount = 'discount',
}

export enum Illustrations {
    'data-fly' = 'data_fly',
    'empty-page' = 'empty_page_illustration',
    giftcard = 'giftcard',
    'no-notifications' = 'no_notifs',
    check = 'onboard_check',
    'company-building' = 'onboard_company_building',
    'company-colored' = 'onboard_company_colored',
    'company-gradient' = 'onboard_company_gradient',
    company = 'onboard_company',
    'event-organiser' = 'onboard_event_org',
    'event-org-colored' = 'onboard_event_org_colored',
    'event-org-gradient' = 'onboard_event_org_gradient',
    'onboarding-regular' = 'onboard_regular',
    'onboarding-runner' = 'onboard_runner',
    'service-provider-colored' = 'onboard_serviceprovider_colored',
    'service-provider-gradient' = 'onboard_serviceprovider_gradient',
    'service-provider' = 'onboard_serviceprovider',
    warning = 'onboard_warning',
    'page-not-found' = 'page-not-found',
    'payment-and-registration' = 'payment_and_reg',
    popup = 'pop-up-image',
    search = 'search',
    'search-no-filter-results' = 'search-no-filter-results',
    'sid-no-results' = 'SID_no_results_illustration',
    'sid-no-tickets' = 'SID_no_tickets_illustr',
    training = 'training',
    'empty-search' = 'empty-search',
}

export enum IconFlags {
    est = 'est',
    lva = 'lva',
    ltu = 'ltu',
}

export type IconNameType = keyof typeof Icons;
export type IconColoredNameType = keyof typeof IconsColored;
export type IconSocialNameType = keyof typeof IconsSocial;
export type IllustrationNameType = keyof typeof Illustrations;
export type IconFlagNameType = keyof typeof IconFlags;
export type IconType =
    IconNameType | IconColoredNameType | IconSocialNameType | IllustrationNameType | IconFlagNameType;
